import { ServerError } from './ServerError'

export class ApiError extends Error {
  constructor(message?: string) {
    super(message || '')
  }

  public static from(error?: ServerError): ApiError {
    return new ApiError(error?.error)
  }
}
